import React from 'react';
import { cx } from '../../../../../ui/components/cx';
import './TextArea.scss';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/** Multi-line text control styled like src/ui TextInput. Use inside a Field. */
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({ className, rows = 3, ...rest }, ref) => (
  <textarea ref={ref} rows={rows} className={cx('ds-input', 'tp-textarea', className)} {...rest} />
));
TextArea.displayName = 'TextArea';

export default TextArea;
